export var StreamType;
(function (StreamType) {
    StreamType["DASH"] = "dash";
    StreamType["DASH_WIDEVINE"] = "dash_widevine";
    StreamType["DASH_PLAYREADY"] = "dash_playready";
    StreamType["HLS7"] = "hls7";
    StreamType["HLS7_FAIRPLAY"] = "hls7_fairplay";
    StreamType["SMOOTH"] = "smooth";
    StreamType["MP4"] = "mp4";
    StreamType["WEBM"] = "webm";
})(StreamType || (StreamType = {}));
